import { render, staticRenderFns } from "./ReservationsKanban.vue?vue&type=template&id=88cd40e2&scoped=true&"
import script from "./ReservationsKanban.vue?vue&type=script&lang=js&"
export * from "./ReservationsKanban.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsKanban.vue?vue&type=style&index=0&id=88cd40e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cd40e2",
  null
  
)

export default component.exports